import { CollectionItemType } from "@annunciate/core";
const collectionItemFactory = (__typename, startingId, num) => {
    const items = [];
    for (let i = 0; i < num; i++) {
        const id = -1 * (startingId + i);
        const item = {
            __typename: 'CollectionItem',
            parentId: -999,
            id,
            item: {
                __typename,
                id: -99999999 + id,
                name: '',
            },
            position: id,
        };
        items.push(item);
    }
    return items;
};
export const COLLECTION_ITEMS = [
    ...collectionItemFactory(CollectionItemType.Carousel, 1, 1),
    ...collectionItemFactory(CollectionItemType.Collection, 2, 9),
];
export const COLLECTION_ITEMS_SERIES = collectionItemFactory(CollectionItemType.Content, 1, 7);
export const CAROUSEL_ITEMS = collectionItemFactory(CollectionItemType.Content, 1, 7);
//# sourceMappingURL=index.js.map